module.exports = __webpack_public_path__ + "static/img/8.7882abe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/3/zh/8.png
// module id = G7TP
// module chunks = 0